import './hello-world.css'

/**
 * slot: have limited css styling capabilities >> span is easier to style
 */

const ELEMENT_NAME = 'hello-world'

export function registerHelloWorld () {
  if (customElements.get(ELEMENT_NAME)) return
  customElements.define(ELEMENT_NAME, HelloWorld)
}

class HelloWorld extends HTMLElement {
  // Private field declaration
  #config = {}

  static observedAttributes = ['name', 'color']

  constructor () {
    super()

    console.log('HelloWorld constructor', this)
  }

  attributeChangedCallback (property, oldValue, newValue) {
    console.log('attributeChangedCallback', property, oldValue, newValue, this)
    if (oldValue === newValue) return
    this[property] = newValue

    // Update the UI
    if (!this.querySelector(`span[name="${property}"]`)) return

    this.querySelector(`span[name="${property}"]`).textContent = newValue
  }

  connectedCallback () {
    console.log('connectedCallback', this)

    this.render()
  }

  set name (value) {
    this.setAttribute('name', value)
  }

  get name () {
    return this.getAttribute('name')
  }

  set color (value) {
    this.setAttribute('color', value)
  }

  get color () {
    return this.getAttribute('color')
  }

  get config () {
    console.log('get .config')
    // console.log('this.config', this.config)
    // console.log('this.#config', this.#config)
    return this.#config
    // return this.config
  }

  set config (value) {
    console.log('set .#config')
    this.#config = value
    console.log('this', this)
    console.log('this.config', this.config)
    console.log('this.#config', this.#config)
    this.render() // Update the component when the config changes
  }

  handleInput (event) {
    console.log('handleInput', event.target.value, this)
    const value = event.target.value
    this.querySelector('#input-value').textContent = value

    this.setAttribute('name', value)

    this.dispatchEvent(new CustomEvent('c-inputChanged', {
      detail: { message: 'Form has been submitted!' },
      bubbles: true,
      composed: true
    }))
    console.log('Event dispatched: inputChanged')
  }

  render () {
    console.log('Rendering with config:', this.config)
    console.log('Rendering with #config:', this.#config)

    this.innerHTML = template

    this.querySelector('span[name="name"]').textContent = this.name
    this.querySelector('span[name="color"]').textContent = this.color
    this.querySelector('span[name="userRole"]').textContent = this.config?.user?.role
    this.querySelector('span[name="counter"]').textContent = this.config?.counter

    // Add event listener to the input field
    this.querySelector('#input-name').addEventListener('input', this.handleInput.bind(this))

    // Beware what is 'this'
    const componentThis = this

    this.querySelector('#button-submit').addEventListener('click', function (event) {
      console.log('clicked', event, componentThis._other)
      console.log('clicked', 'this.config', componentThis.config)

      componentThis.config = componentThis.config || {}
      componentThis.config.counter = componentThis.config.counter || 0
      componentThis.config.counter++
      componentThis.render()

      componentThis.dispatchEvent(new CustomEvent('c-clicked', {
        detail: { message: 'Form has been submitted!' },
        bubbles: true,
        composed: true
      }))
      console.log('Event dispatched: clicked')
    })
  }
}

const template = `
  <div>
    <h1>Hello <span name="name">name</span>!</h1>
    <p>Text content [<span name="color">color</span>]</p>
    <input type="text" id="input-name" />
    <p>You typed: <span id="input-value"></span></p>
    <button id="button-submit">Click</button>
    <p>Role? <span name="userRole">...</span>
    <p>Counter? <span name="counter">...</span>
  </div>
`

customElements.define(ELEMENT_NAME, HelloWorld)
